export default "__VITE_ASSET__BTkTVqcM__"